module.exports = __webpack_public_path__ + "static/marki-8a533056028c5f1893d6769f60d68e7f.jpg";